import React from "react";
import { useSelector } from "react-redux";

import { FloorsVisualStep } from "../../modules/VisualStep";
import { FlatsVisualStep } from "../../modules/VisualStep";
import HeaderInfo from "../../components/HeaderInfo/HeaderInfo";

const VisualChooserPage = () => {
	const { step } = useSelector((state) => state.visual);

	const complexId = document
		.querySelector("section.chooser.visual")
		?.getAttribute("data-complex-id");
	const complexName = document
		.querySelector("section.chooser")
		?.getAttribute("data-complex-name");
	const isMainPage =
		location.pathname.includes('apartments');

	return (
		<>
			{isMainPage && <HeaderInfo object={complexName} isVisual={true} />}
			{step === "floors" ? (
				<FloorsVisualStep complexId={complexId} />
			) : (
				<FlatsVisualStep complexId={complexId} />
			)}
		</>
	);
};

export default VisualChooserPage;
